import { motion } from "framer-motion";
const VideoThumbnailWrapper = ({
  children
}) => {
  return <motion.div className="relative cursor-pointer overflow-hidden" initial="rest" whileHover="hover" animate="rest" data-sentry-element="unknown" data-sentry-component="VideoThumbnailWrapper" data-sentry-source-file="VideoThumbnailWrapper.jsx">
      {children}
      <div className="absolute inset-0 bottom-0 left-0 right-0 top-0 flex items-center justify-center">
        <motion.div className="text-icon-color bg-icon-bg/50 z-10 flex h-8 w-8 scale-[1] items-center justify-center rounded-full hover:scale-[1.1]" data-sentry-element="unknown" data-sentry-source-file="VideoThumbnailWrapper.jsx">
          <svg viewBox="0 0 448 512" width="12px" height="12px" xmlns="http://www.w3.org/2000/svg" className="ms-1" data-sentry-element="svg" data-sentry-source-file="VideoThumbnailWrapper.jsx">
            <path d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.3 43.1 57.3 72.4 40.5L424.4 297.3c28.9-17.7 28.9-61.9 0-71.6z" fill="currentColor" data-sentry-element="path" data-sentry-source-file="VideoThumbnailWrapper.jsx" />
          </svg>
        </motion.div>
      </div>
    </motion.div>;
};
export default VideoThumbnailWrapper;